/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProfilingWizardChecklistItem } from './ProfilingWizardChecklistItem';
import {
    ProfilingWizardChecklistItemFromJSON,
    ProfilingWizardChecklistItemFromJSONTyped,
    ProfilingWizardChecklistItemToJSON,
    ProfilingWizardChecklistItemToJSONTyped,
} from './ProfilingWizardChecklistItem';

/**
 * 
 * @export
 * @interface ProfilingWizardStatusResponse
 */
export interface ProfilingWizardStatusResponse {
    /**
     * Indicates whether the Profiling Wizard is complete.
     * @type {boolean}
     * @memberof ProfilingWizardStatusResponse
     */
    isComplete: boolean;
    /**
     * Steps needed to complete the profiling of the business relation, to be shown in the Products section of the Profiling Wizard. A step the business relation does not need is left out.
     * @type {Array<ProfilingWizardChecklistItem>}
     * @memberof ProfilingWizardStatusResponse
     */
    checklist: Array<ProfilingWizardChecklistItem>;
}

/**
 * Check if a given object implements the ProfilingWizardStatusResponse interface.
 */
export function instanceOfProfilingWizardStatusResponse(value: object): value is ProfilingWizardStatusResponse {
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    if (!('checklist' in value) || value['checklist'] === undefined) return false;
    return true;
}

export function ProfilingWizardStatusResponseFromJSON(json: any): ProfilingWizardStatusResponse {
    return ProfilingWizardStatusResponseFromJSONTyped(json, false);
}

export function ProfilingWizardStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfilingWizardStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isComplete': json['isComplete'],
        'checklist': ((json['checklist'] as Array<any>).map(ProfilingWizardChecklistItemFromJSON)),
    };
}

export function ProfilingWizardStatusResponseToJSON(json: any): ProfilingWizardStatusResponse {
    return ProfilingWizardStatusResponseToJSONTyped(json, false);
}

export function ProfilingWizardStatusResponseToJSONTyped(value?: ProfilingWizardStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isComplete': value['isComplete'],
        'checklist': ((value['checklist'] as Array<any>).map(ProfilingWizardChecklistItemToJSON)),
    };
}

